import React from "react";
import "./Header.css";

const Header = ({ hasRetailGidGroup }) => {
  console.log("Header-RetailGID.js: hasRetailGidGroup", hasRetailGidGroup);

  return (
    <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-black justify-content-between">
      <div className="navbar-brand ncss-brand u-uppercase">
        <span className="text-color-white display-3">
          <i className="g72-swoosh"></i> Retail GID Account Management
        </span>
      </div>
      <div className="navbar-nav">
        <div className="nav-item">
          <a className="nav-link text-color-white" href="/">
            ServiceDesk-Assisted Password Reset
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
